import React from "react";
import GetInitials from "../GetInitials";
import { isEmpty } from "lodash";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WarningModal from "../WarningModal/WarningModal";
import DeleteThisRequestModel from "../DeleteThisRequestModel";
import { OPTIONS_DATA_MAPPER, ssnMasking, usDateFormat } from "../../utils";

const DraftCard = ({
  key,
  title,
  employeeRolloverinRolloverin,
  draftemployeeRolloverinData,
  employeeRolloverin,
  setShowModal,
  filter,
  setDeleteemployeeRolloverin,
  setDeleteEmployee,
  pendingApproval,
  setemployeeRolloverin,
  setListemployeeRolloverin,
  listemployeeRolloverin,
  onClickOfCard,
}) => {
  return (
    <div className="draftCard-style">
      <div
        className="d-flex"
        style={{ justifyContent: "center", alignItems: "center" }}
        onClick={() => {
          onClickOfCard();
        }}
      >
        <div className="employeeRolloverin-icon-wrapper d-flex justify-content-center">
          {!isEmpty(employeeRolloverin.imageURL) ? (
            <img
              alt=""
              src={employeeRolloverin.imageURL}
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                marginTop: "15px",
              }}
              className="img-fluid"
            />
          ) : (
            <div
              style={{
                marginBottom: "15%",
                marginRight: "150px",
                marginTop: "15%",
              }}
            >
              <GetInitials name={employeeRolloverin.employeeName} />
            </div>
          )}
          {/* vertical line */}
          <div className="verticalLine"></div>
        </div>

        <div
          style={{
            marginBottom: "30px",
            flexDirection: "column",
            whiteSpace: "nowrap",
          }}
        >
          <div className="draftCardemployeeRolloverinName">
            {employeeRolloverin.employeeName}
          </div>

          <div
            style={{
              fontWeight: "400",
              fontSize: "14px",
              color: "#777777",
            }}
          >
            {ssnMasking(employeeRolloverin.ssn)}
          </div>
        </div>

        {/* <div
        style={{ marginBottom: "30px", whiteSpace: "nowrap" }}
        className="type"
      >
        {title?.type}
        <div className="type-ans">separtion from service</div>
      </div> */}
        <div
          style={{
            marginBottom: "30px",
            whiteSpace: "nowrap",
            marginLeft: "30px",
          }}
          className="type"
        >
          {"Request raised by"}

          <div className="type-ans">
            {filter === "Rolloverin" && employeeRolloverin.requestedBy}
          </div>
          <div className="type-ans">
            {(() => {
              if (filter === "Withdrawals") {
                if (employeeRolloverin.requestedBy === 1) {
                  return <div>{OPTIONS_DATA_MAPPER.USER_ROLES[1]}</div>;
                } else if (employeeRolloverin.requestedBy === 2) {
                  return <div>{OPTIONS_DATA_MAPPER.USER_ROLES[2]}</div>;
                } else if (employeeRolloverin.requestedBy === 3) {
                  return <div>{OPTIONS_DATA_MAPPER.USER_ROLES[3]}</div>;
                } else if (employeeRolloverin.requestedBy === 4) {
                  return <div>{OPTIONS_DATA_MAPPER.USER_ROLES[4]}</div>;
                } else if (employeeRolloverin.requestedBy === 5) {
                  return <div>{OPTIONS_DATA_MAPPER.USER_ROLES[5]}</div>;
                } else if (employeeRolloverin.requestedBy === 6) {
                  return <div>{OPTIONS_DATA_MAPPER.USER_ROLES[6]}</div>;
                }
              }
            })()}
          </div>
        </div>
        <div
          style={{
            marginBottom: "30px",
            whiteSpace: "nowrap",
            marginLeft: "30px",
          }}
          className="type"
        >
          {"Requested Date"}
          <div className="type-ans">
            {usDateFormat(employeeRolloverin.requestedOn)}
          </div>
        </div>

        {/* vertical line */}
        <div
          style={{
            height: "70px",
            borderRight: "1px solid #F2F2F2",
            marginBottom: "5px",
            marginLeft: "30px",
          }}
        ></div>
      </div>

      <div>
        <FontAwesomeIcon
          icon={faTrashAlt}
          size="13px"
          color="#FF0000"
          style={{ cursor: "default" }}
          onClick={() => {
            setShowModal(true);
            setDeleteEmployee(employeeRolloverin);
          }}
          //onClick={()=>alert("hi")}
        />
      </div>
    </div>
  );
};

export default DraftCard;
